import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
//import { useNavigate } from 'react-router-dom';
//import { useAppDispatch } from '../../hooks/store';
import { useAppSelector } from '../../hooks/store';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Slot, Attendee, Request } from '../../types';
import SlotLock from './SlotLock';
//import { attendeeSet } from '../../store/attendeeSlice';
import RequestView from '../../modal/RequestView';

export interface SlotItemProps {
	slot: Slot,
};

const SlotItem: FC<SlotItemProps> = ({ slot }) => {
	const { t, i18n } = useTranslation();
    //const lang = i18n.language === 'en' ? 'en' : 'ru';
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const company = i18n.language === 'en' ? 'company_en' : 'company_ru';
    const duration = i18n.language === 'en' ? 'min' : 'мин';
    //const dispatch = useAppDispatch();
    //const navigate = useNavigate();
    const user = useAppSelector(store => store.auth.user);
    const attendees = useAppSelector(store => store.attendees);
    const requests = useAppSelector(store => store.requests);
    const [ time, setTime ] = useState('');
    const [ style, setStyle ] = useState('free');
    const [ respondent, setRespondent ] = useState<Attendee|null>(null);
    const [ isIncoming, setIsIncoming ] = useState(false);
    const [ lockRequestId, setLockRequestId ] = useState(0);
    const [ request, setRequest ] = useState<Request|undefined>(undefined);
    const [ isRequestViewOpen, setIsRequestViewOpen ] = useState(false);

    useEffect(() => {
        const [ hour, min ] = slot.start.split('T')[1].split(':');
        setTime(`${hour}:${min}`);
        setStyle('free');
        setRespondent(null);
        setLockRequestId(0);
        // Найдем все активные запросы
        const request = requests.find(r => r.slot_id === slot.id && (r.status === 'approved' || r.status === 'negotiation'));
        setRequest(request);
        // На этот слот нет запроса
        if(!request) return;
        // Запрос отправленный самому себе служит для отметки запрещенного слота
        if(request.from_id === request.to_id) {
            setStyle('disabled');
            setLockRequestId(request.id);
            return;
        }
        // Будем окрашивать слот в соответствии с его статусом
        setStyle(request.status);
        // Узнаем входящий это запрос или исходящий
        if(request.to_id === user?.id) setIsIncoming(true); else setIsIncoming(false);
        // Определим собеседника
        const attendee = attendees.find(a => a.id === request.from_id || a.id === request.to_id);
        if(attendee) setRespondent(attendee);
    }, [ slot, requests, attendees, user ])

    const onClick = () => {
        // Для перехода на страницу собеседника можно использовать этот блок.
        /*
        if(respondent) {
            dispatch(attendeeSet(respondent));
            navigate('attendee');
        }
        */
        // Но нас попросили сразу показывать попап с информацией о встрече
        if(request) {
            setIsRequestViewOpen(true);
        }
    };

	return (
        <div onClick={onClick} className={respondent ? `SlotItem ${style}` : `SlotItem ${style} nopointer`}>
            <div className='Time'>{time}</div>
            <div className='Duration'>{slot.duration}&nbsp;{duration}</div>

            {(style === 'free' || style === 'disabled') && <>
                <SlotLock slot_id={slot.id} request_id={lockRequestId}/>
                <div>{t('profile.slot.' + style)}</div>
            </>}

            {style === 'negotiation' && <span className='Tooltip Icon'>
                {isIncoming ? <Icon icon={faArrowDown}/> : <Icon icon={faArrowUp}/>}
                <span className='TooltipText'>{t('search.negotiation')}</span>
            </span>}

            {style === 'approved' && <span className='Tooltip Icon'>
                <Icon icon={faCheck}/>
                <span className='TooltipText'>{t('search.approved')}</span>
            </span>}

            {respondent && <div>{respondent[name]}<br/><small>{respondent[company]}</small></div>}

            <RequestView
                request={request}
                isOpen={isRequestViewOpen}
                onClose={() => setIsRequestViewOpen(false)}
            />
        </div>
	);
};

export default SlotItem;
